import React from 'react';
import { Sparkles } from 'lucide-react';
import Container from './Container';
import Button from './Button';
import ParticleBackground from './ParticleBackground';

const Hero: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-background to-background/90 pt-20">
      <ParticleBackground />
      
      <Container className="relative z-10 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary ring-1 ring-inset ring-primary/20 mb-6">
            <Sparkles size={16} className="mr-1" />
            <span>Beta Access Coming Soon</span>
          </div>
          
          <h1 className="mb-6 max-w-4xl bg-gradient-to-br from-foreground to-foreground/80 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl md:text-6xl lg:text-7xl">
            Create Amazing Games with <span className="bg-gradient-to-r from-primary to-purple-500 bg-clip-text text-transparent">AI-Powered Tools</span>
          </h1>
          
          <p className="mb-8 max-w-2xl text-lg text-muted-foreground sm:text-xl">
            Wizantix empowers anyone to become a game developer without programming knowledge. Use AI generators, no-code tools, or our GDK for experienced developers.
          </p>
          
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
            <Button size="lg" onClick={() => document.getElementById('CalltoAction')?.scrollIntoView({ behavior: 'smooth' })}>
              Join Waitlist
            </Button>
            <Button variant="outline" size="lg">Learn More</Button>
          </div>
          
          <div className="mt-16 relative">
            <div className="absolute -inset-0.5 rounded-lg bg-gradient-to-r from-primary to-purple-500 opacity-75 blur"></div>
            <div className="relative rounded-lg border border-border bg-card p-2 shadow-lg">
              <img
                src="assets/banner.jpg"
                alt="Game development interface"
                className="rounded-lg w-full shadow-sm"
                width={1200}
                height={675}
              />
            </div>
          </div>
        </div>
      </Container>
      
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-background to-transparent"></div>
    </section>
  );
};

export default Hero;